import dayjs from "dayjs";

export function formatDate(date: Date | string) {
  const dt = dayjs(date);
  if (!dt.isValid()) return "-";
  return dt.format("DD/MM/YYYY");
}
